// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/RequesterCheckField/index.tsx

import { useCheckboxField } from '@modusign/react-signing';
import { Size } from '@modusign/react-signing/types';
import { useCallback } from 'react';

import { clampFieldPoint } from '@app/features/apply-react-signing/components/FieldRenderer/libs/clampFieldPoint';
import { RequesterCheckboxField } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/components/RequesterFields/RequesterCheckboxField';
import {
  Point,
  ReactSigningFieldRendererProps,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';
import { useOptimalFieldsContext } from '@app/features/apply-react-signing/libs/hooks/useCollectionOptimal';

function RequesterCheckboxFieldRenderer({
  fieldId,
  initialContextMenuOpened = true,
  isDataLabelEditable = true,
  showFieldNumber,
  isPreview,
  readOnly,
  viewport,
}: ReactSigningFieldRendererProps) {
  const { field, setDataLabel, setPosition, setSize, setValue } = useCheckboxField(fieldId);

  const {
    evaluated: { isDataLabelDuplicated, fieldNumber },
    removeField,
  } = useOptimalFieldsContext<'CHECKBOX', 'REQUESTER'>();

  const onSizeChange = useCallback(
    (size: Size) => {
      setSize(size.width, size.height);
    },
    [setSize]
  );

  const onPointChange = useCallback(
    (point: Point) => {
      const clampedPoint = clampFieldPoint(point);
      setPosition(clampedPoint.x, clampedPoint.y);
    },
    [setPosition]
  );

  if (field == null || field.type !== 'CHECKBOX') {
    return null;
  }

  return (
    <RequesterCheckboxField
      field={field}
      fieldNumber={showFieldNumber ? fieldNumber : undefined}
      initialContextMenuOpened={initialContextMenuOpened}
      isDataLabelDuplicated={isDataLabelDuplicated}
      isDataLabelEditable={isDataLabelEditable}
      isPreview={isPreview}
      readOnly={readOnly}
      viewport={viewport}
      onCheckedChange={setValue}
      onDataLabelChange={setDataLabel}
      onFieldRemove={removeField}
      onPointChange={onPointChange}
      onSizeChange={onSizeChange}
    />
  );
}

export default RequesterCheckboxFieldRenderer;
